import React from 'react';
import { List, Datagrid, TextField, EditButton } from 'react-admin';

const TypesList = (props) => (
  <List title="Types" exporter={false} bulkActionButtons={false} sort={{ field: 'id', order: 'DESC' }} {...props}>
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField label="Name" source="name" />
      <TextField label="Title" source="title" sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export default TypesList;
